import Store from 'lightningjs-redux';
import { getRequestedEntityType } from '../../../logic/layout/layout.selectors';

const mapControllers = instance => [
  {
    shouldBeInvokedOnConnect: true,
    selector: getRequestedEntityType,
    callback: value => {
      instance.entityType = value;
    },
  },
];

export default Store.control(mapControllers);
